export default {
  homePage: 'Página inicial',
  site: {
    title: 'Site',
    editSite: 'Editar site',
    manageDomain: 'Definir domínio',
    manageFavicon: 'Definir ícone'
  },
  email: 'E-mail'
}
